import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

import { prettifySize } from 'utils/prettify';


@Pipe({name: 'prettifySize'})
export class PrettifySizePipe implements PipeTransform {
  transform(value: any): any {
    if (_.isNaN(value)) { return value; }
    return prettifySize(value);
  }
}
